/**
 * Полоса жизни с откликом на удар (Джон 05.11.2026, 00:11: «визуально плохо видно на полосе жизни эффект… как в Тэйкен,
 * что бы прям очевидно было, какой мощный удар это был»): выбитый кусок вспыхивает белым и откалывается осколками,
 * полоса вздрагивает тем сильнее, чем больше сняли, след потерянного тает с задержкой, серое здоровье (можно отыграть) —
 * своим цветом. Только картинка: читает здоровье из мира, ничего в нём не меняет.
 */
const FLASH_FRAMES = 10;
const TRAIL_DELAY = 28;
const TRAIL_MELT = 0.006;
const SHARDS = 9;

interface Chip {
  from: number;
  to: number;
  age: number;
}

export interface BarGeometry {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly mirrored: boolean;
}

export class HealthBar {
  private last = 1;
  private trail = 1;
  private hold = 0;
  private shake = 0;
  private chips: Chip[] = [];

  /** Кадр полосы: доли от полного здоровья — здоровье и серое; low — последний шанс (полоса дышит). */
  draw(
    context: CanvasRenderingContext2D,
    bar: BarGeometry,
    health: number,
    grey: number,
    low: boolean,
    tick: number,
  ): void {
    if (health < this.last - 0.0005) {
      const lost = this.last - health;
      this.chips.push({ from: health, to: this.last, age: 0 });
      this.shake = Math.max(this.shake, Math.min(14, 3 + lost * 160));
      this.hold = TRAIL_DELAY;
    }
    this.last = health;
    if (this.hold > 0) this.hold--;
    else this.trail = Math.max(health + grey, this.trail - TRAIL_MELT);
    if (this.trail < health + grey) this.trail = health + grey;
    const jolt = this.shake > 0.3 ? Math.round((tick % 2 === 0 ? 1 : -1) * this.shake) : 0;
    this.shake *= 0.82;
    const x = bar.x + jolt;
    const part = (value: number): [number, number] => {
      const width = Math.round(bar.width * Math.max(0, Math.min(1, value)));
      return [bar.mirrored ? x : x + bar.width - width, width];
    };
    // кусок между долями from и to: у правой полосы (mirrored) — от левого края, у левой — от правого
    const span = (from: number, to: number): [number, number] => {
      const width = Math.round(bar.width * (to - from));
      return bar.mirrored
        ? [x + Math.round(bar.width * from), width]
        : [x + bar.width - Math.round(bar.width * to), width];
    };
    context.fillStyle = "#0b0910";
    context.fillRect(x - 6, bar.y - 6, bar.width + 12, bar.height + 12);
    context.fillStyle = "#3a1016";
    context.fillRect(x, bar.y, bar.width, bar.height);
    // след потерянного: тает с задержкой
    {
      const [left, width] = part(this.trail);
      context.fillStyle = "#f2a040";
      context.fillRect(left, bar.y, width, bar.height);
    }
    // серое: можно отыграть атакой
    {
      const [left, width] = part(health + grey);
      context.fillStyle = "#9a96a6";
      context.fillRect(left, bar.y, width, bar.height);
    }
    {
      const [left, width] = part(health);
      const pulse = low ? 0.5 + 0.5 * Math.sin(tick * 0.25) : 0;
      context.fillStyle = low ? `rgb(${String(200 + Math.round(55 * pulse))}, 30, 40)` : "#c81e28";
      context.fillRect(left, bar.y, width, bar.height);
      context.fillStyle = "#ff6a5a";
      context.fillRect(left, bar.y, width, 8);
    }
    // выбитый кусок: белая вспышка на месте снятого, потом осколки разлетаются вниз
    this.chips = this.chips.filter((chip) => chip.age < FLASH_FRAMES + 24);
    for (const chip of this.chips) {
      const [left, width] = span(chip.from, chip.to);
      if (chip.age < FLASH_FRAMES) {
        context.fillStyle = `rgba(255, 255, 255, ${(1 - chip.age / FLASH_FRAMES).toFixed(3)})`;
        context.fillRect(left, bar.y - 3, Math.max(2, width), bar.height + 6);
      } else {
        const t = chip.age - FLASH_FRAMES;
        context.fillStyle = `rgba(255, 210, 190, ${(1 - t / 24).toFixed(3)})`;
        for (let shard = 0; shard < SHARDS; shard++) {
          const sx = left + ((shard + 0.5) / SHARDS) * Math.max(6, width);
          const drift = ((shard * 37) % 11) - 5;
          context.fillRect(sx + drift * t * 0.4, bar.y + bar.height + t * (1.5 + (shard % 3)), 5, 5);
        }
      }
      chip.age++;
    }
  }

  reset(): void {
    this.last = 1;
    this.trail = 1;
    this.hold = 0;
    this.shake = 0;
    this.chips = [];
  }
}
